import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Faq from "../components/Faq";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faHouse,
  faWallet,
  faCreditCard,
  faPiggyBank,
  faHeartPulse,
  faHandHoldingHeart,
  faClipboardCheck,
  faComments,
  faScaleBalanced,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/dualEducation.css";
import TileGrid from "../components/TileGrid";
import ProcessSteps from "../components/ProcessSteps";
import { RETAIL_ROUTES } from "../lib/siteMode";

const PRODUCTS = [
  {
    icon: faWallet,
    title: "Személyi kölcsön",
    description:
      "Szabad felhasználású hitel fedezet nélkül, gyors bírálattal. Folyósítás akár 24 órán belül.",
    to: RETAIL_ROUTES.szemelyiKolcson,
  },
  {
    icon: faHouse,
    title: "Lakáshitel",
    description:
      "Fix kamatozású hitelek, Otthon Start vagy CSOK Plusz? Segítünk megtalálni a megfelelő választást.",
    to: RETAIL_ROUTES.jelzaloghitel,
  },
  {
    icon: faCreditCard,
    title: "Bankszámla",
    description:
      "Nézd meg a legkedvezőbb bankszámlák díjait, és spórolj akár 100 ezer forintot éves szinten.",
    to: RETAIL_ROUTES.bankszamla,
  },
  {
    icon: faHandHoldingHeart,
    title: "Támogatott termékek",
    description:
      "Babaváró hitel, Munkáshitel, CSOK Plusz? — Segítünk elérni az állami támogatású kedvezményes konstrukciókat.",
    to: RETAIL_ROUTES.szemelyiKolcson,
  },
  {
    icon: faPiggyBank,
    title: "Nyugdíjmegtakarítás",
    description:
      "Önkéntes nyugdíjpénztár, nyugdíjbiztosítás vagy NYESZ? Segítünk kihasználni az elérhető állami támogatásokat.",
    to: RETAIL_ROUTES.nyugdijmegtakaritas,
  },
  {
    icon: faHeartPulse,
    title: "Életbiztosítás",
    description:
      "Segítünk megtalálni a megfelelő életbiztosítást, ahol a havi díj mellett az ügyintézés egyszerűse is szempont.",
    to: RETAIL_ROUTES.eletbiztositas,
  },
];

const PROCESS_STEPS = [
  {
    icon: faClipboardCheck,
    title: "Mondd el, mire van szükséged",
    description:
      "Töltsd ki kalkulátorunkat, vagy vedd fel velünk a kapcsolatot pár kattintással.",
  },
  {
    icon: faComments,
    title: "Ingyenes, személyes konzultáció",
    description:
      "Tanácsadónk átbeszéli veled az igényeidet és a lehetőségeidet, kötelezettség nélkül.",
  },
  {
    icon: faScaleBalanced,
    title: "Versenyeztetjük a bankokat",
    description:
      "Több pénzintézet ajánlatát hasonlítjuk össze, hogy a piac legjobb konstrukcióját találjuk meg neked.",
  },
  {
    icon: faFileSignature,
    title: "Végigkísérünk a szerződésig",
    description:
      "Intézzük az ügyintézést, akár teljesen online, egészen a szerződéskötésig.",
  },
];

export default function LakossagiHome() {
  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <h1 className="title ms-1 ms-md-0">
          Találd meg a legjobb ajánlatot
          <br />
          <span style={{ color: "#c7d2fe" }}>és spórolj százezreket!</span>
        </h1>

        <p className="subtitle mb-0 ms-1 ms-md-0">
          Hitelek, biztosítások, támogatások – egy helyen, objektíven
          összehasonlítva. Számolj kalkulátorainkkal, és kollégáink segítenek a
          legjobb ajánlat kiválasztásában!
          <br />
        </p>
      </Container>
      <Container id="termekek">
        <TileGrid items={PRODUCTS} />

        <section id="hogyan-segitunk" className="mt-5">
          <h2 className="h2 text-center mb-2">Hogyan tudunk segíteni?</h2>
          <p className="process-steps-intro text-center mx-auto">
            Az első egyeztetéstől a szerződéskötésig végigkísérünk — íme, hogyan
            néz ki nálunk az együttműködés.
          </p>
          <ProcessSteps steps={PROCESS_STEPS} className="mt-4" />
        </section>

        <section id="miert-mi" className=" mt-5">
          <h2 className="h2">Miért érdemes velünk intézni?</h2>
          <Row className="g-4 mt-2">
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Bankfüggetlenség:</strong> Nem egyetlen bank
                    ajánlatát mutatjuk, hanem több pénzintézetet versenyeztetünk
                    érted.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Díjmentes ügyintézés:</strong> Az ajánlatkérés és a
                    teljes körű tanácsadás számodra ingyenes.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Online ügyintézés:</strong> Segítünk
                    hiteligénylésben és bankszámlanyitásban akár{" "}
                    <strong>teljesen online</strong>!
                  </div>
                </li>
              </ul>
            </Col>
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Időmegtakarítás:</strong> Egyetlen adatközléssel
                    több bank ajánlatát is megkapod, sorban állás nélkül.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Szakértői támogatás:</strong> Végigkísérünk az első
                    kalkulációtól a szerződéskötésig.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Szakmai tapasztalat:</strong> Kollégáink több éves
                    szakmai múltja segít abban, hogy a megfelelő banki
                    kiszolgálásban legyen részed.
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </section>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Mennyibe kerül a szolgáltatás?",
                    answer:
                      "Az ügyfelek számára az ajánlatkérés, a bankok versenyeztetése és a teljes körű tanácsadás díjmentes. Kötelezettséget nem vállalsz azzal, hogy ajánlatot kérsz.",
                  },
                  {
                    question: "Mit tudok itt összehasonlítani?",
                    answer:
                      "Jelzáloghitelt, személyi kölcsönt és lakossági bankszámlát – mindegyikhez külön kalkulátort vagy összehasonlító táblázatot és részletes útmutatót találsz. Válaszd ki a fenti termékek közül, ami érdekel.",
                  },
                  {
                    question: "Mennyi idő alatt kapok visszajelzést?",
                    answer:
                      "Az űrlap elküldése után munkatársunk hamarosan felveszi veled a kapcsolatot, és egyeztet a számodra legkedvezőbb lehetőségekről. A pontos ügyintézési idő a választott terméktől függ.",
                  },
                ],
              },
              {
                key: "bankszamla",
                label: "Bankszámla",
                items: [
                  {
                    question: "Létezik ingyenes bankszámla?",
                    answer:
                      "Igen, Magyarországon is léteznek ingyenes bankszámlák, amennyiben teljesítjük az ezekhez szükséges feltételeket.",
                  },
                  {
                    question: "Mennyibe kerül a bankkártyás vásárlás?",
                    answer:
                      "A bankkártyás vásárlás az ügyfél számára ingyenes, az elfogadó üzletnek kell bizonyos jutalékot fizetnie a bank felé.",
                  },
                  {
                    question: "Biztonságban van a pénzem a bankszámlán?",
                    answer:
                      "A bankszámlán elhelyezett pénzünkre az Országos Betétbiztosítási Alap (OBA) garanciája vonatkozik, személyenként és bankonként 100 000 eurós (kb. 36 millió forintos) összeghatárig. Nagyobb összegű megtakarítás esetén a pénzünket akár több banknál is el lehet helyezni, így az OBA által biztosított garancia megtöbbszörözhető.",
                  },
                  {
                    question:
                      "Tudok anélkül bankszámlát nyitni, hogy be kelljen mennem a bankfiókba?",
                    answer:
                      "Igen, a legtöbb bank esetében már van lehetőség online számlanyitásra.",
                  },
                  {
                    question: "Hány éves kortól lehet valakinek bankszámlája?",
                    answer:
                      "Már 6-7 éves kortól is lehet bankszámlát nyitni a gyermekek számára, de a legtöbb pénzintézetnél 14 év az alsó korhatár.",
                  },
                  {
                    question: "Mennyi idő alatt érkezik meg az elutalt pénz?",
                    answer:
                      "2020. március 2-án élesedett Magyarországon az úgynevezett azonnali fizetési rendszer, melynek köszönhetően a hét minden napján, 0-24 órában lehet egyszeri átutalásokat intézni, és ezek 5 másodpercen belül célba is érkeznek.",
                  },
                  {
                    question: "Hogyan vehetek fel ingyenesen készpénzt?",
                    answer:
                      "Havi két alkalommal, összesen 150 000 Ft összeghatárig díjmentesen vehetünk fel készpénzt a bankszámlánkról, mégpedig bármelyik bank bankjegykiadó automatájából. Fontos azonban, hogy erről nyilatkoznunk kell a számlavezető bankunknál, a lehetőség pedig személyenként egy bankszámlára él.",
                  },
                  {
                    question: "Milyen költségei lehetnek egy bankszámlának?",
                    answer:
                      "A leggyakrabban előforduló bankszámla-költségelemek: havi számlavezetési díj, készpénzfelvételi díj, utalási díj, SMS-díj, kártyadíj. Ezeken felül léteznek még egyéb költségtípusok, melyek mértéke mindig az adott számlacsomagtól függ.",
                  },
                  {
                    question: "Lehet-e több személynek közös bankszámlája?",
                    answer:
                      "Egyes bankoknál és bizonyos feltételek mellett lehet több tulajdonosa egyazon bankszámlának, azonban az ezzel járó nehézségek miatt már vannak bankok, amelyek ezt teljesen kivezették a kínálatukból.",
                  },
                  {
                    question: "Lehet egyszerre több bankszámlám?",
                    answer:
                      "Bármely hazai pénzintézetnél van lehetőségünk bankszámlát nyitni, egy személynek pedig több banknál is lehet számlája egyszerre.",
                  },
                ],
              },
              {
                key: "allampapir",
                label: "Állampapír",
                items: [
                  {
                    question: "Mi az az állampapír?",
                    answer:
                      "Az állampapír napjaink egyik legnépszerűbb befektetése. A kínálatban államkötvények és kincstárjegyek találhatóak. Ezek definíció szerint hitelviszonyt megtestesítő értékpapírok: megvásárlásukkal a befektetők lényegében kölcsönt adnak az államnak. Az állampapír-befektetések révén a vevők nyereségre tehetnek szert, míg az állam finanszírozási forráshoz jut.",
                  },
                  {
                    question:
                      "Miből keletkezik a befektetők nyeresége, ha állampapírt vásárolnak?",
                    answer:
                      "Az állampapír a futamidő alatt meghatározott rendszerességgel kamatot fizet, lejáratkor pedig a tőkét is törleszti. Egy 2 éves futamidejű, évi 5 százalékos kamatozású állampapír például a kibocsátásától számított 1 év elteltével 5 százalék kamatot fizet a tőke után, újabb egy év elteltével kifizeti a második évre járó 5 százalék kamatot, ezzel egyidejűleg a tőkét is visszafizeti a befektetőknek. A kamatfizetések gyakorisága eltérő, sőt van olyan államkötvény, amely nem fizet kamatot, hanem a hozama úgy keletkezik, hogy kibocsátásakor olcsóbban lehet megvásárolni, mint amekkora összeget a lejáratkor (a futamidő végén) kap a befektető.",
                  },
                  {
                    question: "Milyen típusai vannak az állampapíroknak?",
                    answer:
                      "Az állampapírokat több szempont alapján csoportosíthatjuk. Megkülönböztethetünk forintban vagy devizában kibocsátott állampapírokat, rövid vagy hosszú lejáratú, fix vagy változó kamatozású állampapírokat egyebek mellett. Vannak ezek között olyanok, amelyeket csak, illetve elsősorban természetes személyek vásárolhatnak meg – ezek a lakossági állampapírok. Vannak továbbá olyanok is, amelyeket intézmények részére bocsátanak ki – ezek az intézményi állampapírok.",
                  },
                  {
                    question: "Mi garantálja a pénzem biztonságát?",
                    answer:
                      "Az állampapírok mögött nem betétbiztosítás áll, hanem maga a kibocsátó, azaz a magyar állam fizetőképessége garantálja a befektetés biztonságát. Mivel az állam a saját devizájában (forintban) bocsátja ki ezeket az értékpapírokat, és jogában áll pénzt teremteni, a forintban kibocsátott állampapírok e szempontból kockázatmentesnek tekinthetők.",
                  },
                  {
                    question: "Mekkora hozamot érhetünk el az állampapírokkal?",
                    answer:
                      "Az állampapírokkal elérhető hozam mértéke változó, az aktuális kamatkörnyezet számottevően befolyásolja. Korábban különösen népszerű volt az inflációkövető állampapír, amelynek kamata nem fix, hanem évente változik, mégpedig oly módon, hogy az előző évi infláció felett biztosít meghatározott mértékű kamatprémiumot. Így alkalmas arra, hogy megőrizze a befektetett pénz reálértékét. Az infláció mérséklődésével a vevők inkább a fix kamatozású állampapírok felé fordultak, például jelenleg igen népszerű a FixMÁP.",
                  },
                  {
                    question:
                      "Kell adózni az állampapírokkal elért nyereség után?",
                    answer:
                      "A lakosság számára a 2019. június 1. után kibocsátott állampapírok hozama adómentes. Ez praktikusan azt jelenti, hogy aki 1 millió forintot fektet be 1 évre, 10 százalékos kamat mellett, pontosan 100 ezer forint hozamot tehet zsebre, és a nyereségét nem terheli adófizetési kötelezettség. Fontos, hogy a 2019. június 1-ét megelőzően kibocsátott állampapírok esetében adózni kell a nyereség után. Tartós befektetési számla (TBSZ) feltörésekor pedig az azon tartott állampapírok is adókötelessé válnak, ezért állampapírokat nem indokolt TBSZ-en tartani.",
                  },
                  {
                    question: "Milyen időtávra lehet állampapírba fektetni?",
                    answer:
                      "Ma Magyarországon egészen rövid, akár néhány hetes vagy hónapos futamidejű állampapírokkal, valamint több év múlva lejáró kötvényekkel egyaránt találkozhatunk. Több évtizedes állampapírok is léteznek, habár a lakossági portfóliókban ezek ritkán fordulnak elő. Mivel az állampapírok biztonságos befektetések, így a rövid, közép vagy hosszú távra tervező befektetők is előszeretettel választják. Magánszemélyként arra is van lehetőség, hogy akár 5-7 éves futamidejű állampapírokat vásároljunk, de még a lejárat előtt kiszálljunk a befektetésből, és zsebre tegyük az addig megtermelt kamatot is.",
                  },
                  {
                    question: "Van kockázata az állampapír-befektetésnek?",
                    answer:
                      "Kötvénybefektetések esetén alapvetően kétféle kockázatról beszélhetünk: partnerkockázatról és árfolyamkockázatról. A partnerkockázat annak a kockázata, hogy az adós (a kötvény kibocsátója, amely ebben az esetben az állam) nem képes szerződésszerűen kifizetni a követeléseket. A jó hír az, hogy az államnak joga van pénzt teremteni, ezért a saját devizájában kibocsátott állampapírok ebből a szempontból kockázatmentesnek tekinthetők. Az árfolyamkockázat arra utal, hogy a befektetés piaci értéke csökkenhet, azaz kevesebb pénzért lehet eladni az állampapírt, mint amennyiért a befektető megvásárolta. A magyar lakossági állampapíroknál ez a kockázat is mérsékelhető, mert a Magyar Államkincstár nagyon kedvező napi árfolyamon visszavásárolja a lakossági állampapírokat: a tőkeveszteség az elmúlt években minimális (0,5-1 százalék közötti) mértékű volt.",
                  },
                  {
                    question: "Ki vásárolhat állampapírt?",
                    answer:
                      "Magyar állampapírokat magánszemélyek és intézmények (vállalatok, bankok, befektetési alapok, nyugdíjpénztárak) is vásárolhatnak. Léteznek azonban csak a lakosság számára elérhető állampapírok, amelyeket kizárólag természetes személyek vásárolhatnak meg: ilyen a Bónusz Magyar Állampapír, a Prémium Magyar Állampapír. Gyermekek részére is lehet állampapírt venni, erre kézenfekvő alternatíva a Babakötvény.",
                  },
                  {
                    question:
                      "Mi az a legkisebb összeg, amit befektethetünk állampapírba?",
                    answer:
                      "A magyar állampapíroknál általában 1 forint vagy 10 ezer forint az alapcímlet, azaz gyakorlatilag bármilyen kis összeggel is elindítható a befektetés. Nem csak egyösszegű befektetés lehetséges (például valaki egyszerre helyez el 5-10 millió forintot), hanem akár havonta is vásárolhatunk állampapírokat, így gyakorlatilag rendszeres megtakarításként lehet élni lehetőséggel. Az sem probléma, ha egy bizonyos időpontban szükségünk lesz a teljes befektetett pénzösszegre, de a felhalmozási időszakban különböző lejáratú állampapírokba helyezzük el a megtakarításainkat. A Magyar Államkincstárnak bármikor értékesíthetjük a megvásárolt kötvényeket, és ilyen esetben az időarányosan felhalmozott kamatot is kifizetik.",
                  },
                  {
                    question: "Hol vásárolhatunk állampapírt?",
                    answer:
                      "Állampapír vásárlásához rendelkeznünk kell egy értékpapírszámlával, amelyet a Magyar Államkincstárnál vagy akár bankoknál és befektetési szolgáltatóknál is megnyithatunk.",
                  },
                  {
                    question:
                      "Mennyi idő egy Magyar Államkincstárnál vezetett értékpapírszámla megnyitása?",
                    answer:
                      "Az Online WebKincstár számla megnyitása mindössze néhány percet vesz igénybe az Ügyfélkapun keresztül. A folyamat gyors és biztonságos, a visszaigazolás pedig perceken belül megérkezik, így a számla azonnal használható állampapírok vásárlására. Alternatívaként személyes számlanyitás is lehetséges, ilyenkor érdemes online időpontot foglalni az államkincstár egyik közeli fiókjába, így nem kell sorban állni. Az ügyintézés nagyjából fél órát vesz igénybe, és a számlatulajdonos már aznap használhatja a Webkincstár vagy Mobilkincstár szolgáltatásait.",
                  },
                ],
              },
              {
                key: "bankbetet",
                label: "Bankbetét",
                items: [
                  {
                    question: "Hogyan működik a bankbetét?",
                    answer:
                      "A bankbetétnél általában egy előre fixált, vagy akár bizonytalan időre lemondasz a pénzedről azért, hogy később többet kapj vissza. Amennyivel növekedett az eredetileg elhelyezett pénzed értéke, azt az összeget nevezzük kamatnak. Bankbetétek zöménél szükséged lesz egy bankszámlára is, amiről a betétlekötést indíthatod.",
                  },
                  {
                    question: "Milyen lekötési típusok vannak?",
                    answer:
                      "Lekötött betéttel találkozhatsz a leggyakrabban: amennyiben nem nyúlsz az előre meghatározott futamidő végéig a pénzhez, megkapod a kamatot. Látra szóló betét inkább a bankszámlákhoz hasonló: nincs fix lejárata, bármikor betehető, kivehető a rajta lévő összeg, a kamatozás napi számítással történik. Megtakarítási betét folyamatos megtakarításokhoz ideális lekötés, ugyanis az ilyen típusú betétek ugyanúgy működnek, mint a látra szóló betétek, de a magasabb (vagy egyáltalán a) kamatért elvárják, hogy minden hónapban gyarapítsd a rajta elhelyezett összeget.",
                  },
                  {
                    question: "Mi alapján válasszak bankbetétet?",
                    answer:
                      "Az első eldöntendő kérdés, hogy milyen típusú lekötött betét lenne neked megfelelő (látra szóló, megtakarítási stb.). Második a futamidő: mennyi időre tudod nélkülözni azt a bizonyos összeget. Harmadik, amit tisztázz magadban, hogy az adott kamatért milyen feltételt vagy hajlandó vállalni (pl.: új pénz a bankhoz utalása, vagy aktív bankkapcsolat). Ezek alapján a kalkulátorunkkal már megkeresheted a legmagasabb kamatot fizető bankbetétet.",
                  },
                  {
                    question: "Milyen futamidőre érdemes lekötni?",
                    answer:
                      "A legjobb betét az, ami a legtöbb kamatot fizeti arra az időre, amire nélkülözni tudod a pénzed. Természetesen nem ilyen egyszerű az élet: ha csökkenő kamatokra számítunk, akkor megérheti egy alacsonyabb kamatozású, de hosszabb lekötés, míg emelkedő kamatok esetén inkább rövid lekötések a preferáltak.",
                  },
                  {
                    question: "Mekkora költségekkel kell számolnom?",
                    answer:
                      "Általában a lekötésnek nincs külön díja. Ám a kamat összegéből már adózni kell: levonják belőle a 15%-os kamatadót illetve a 6%-os egészségügyi hozzájárulást (EHO-t). TBSZ számlával ez elkerülhető.",
                  },
                  {
                    question:
                      "Mi történik, ha feltöröm a betétet lejárat előtt?",
                    answer:
                      "Ha egy lekötött betétet feltörsz, általában teljes kamatveszteséggel kell számolnod. Ez azt jelenti, hogy csak az eredetileg elhelyezett összeget kapod vissza. Ritkább esetben a kamatok egy részét, vagy akár egészét is (időarányosan) kifizeti a bank.",
                  },
                ],
              },
              {
                key: "befektetesi-alap",
                label: "Befektetési alap",
                items: [
                  {
                    question: "Mi az a befektetési alap?",
                    answer:
                      "Úgy kell elképzelni, mint egy közös kasszát, amibe mindenki befizet valamekkora összeget. A kasszát a befizetők a befizetéseik arányaiban tulajdonolják. Hogy mit vegyenek a pénzből, azt szakemberekre, az alapkezelőkre bízzák. Ők egy előre meghatározott, és befektetők által ismert kereten belül eldöntik, hogy mibe is fektessék az így összegyűlt pénzt. A befektetések a befektetési alap kategóriájától függően lehetnek bankbetétek, állampapírok, belföldi vagy nemzetközi részvények, egyéb befektetések, akár ingatlanok is. Ezek fogják meghatározni az alap hozamát.",
                  },
                  {
                    question: "Hol lehet befektetési alapot vásárolni?",
                    answer:
                      "Mivel a befektetési alapok befektetési jegyei nem kerülnek kinyomtatásra (dematerializált értékpapírok), minden esetben rendelkezned kell egy értékpapírszámlával. Értékpapírszámlát nyithatsz a legtöbb nagyobb banknál vagy befektetési szolgáltatónál (brókercég). Ennek a számlának lehetnek költségei, de ezután máris megvásárolhatod a szolgáltatód palettáján megtalálható valamennyi alapot.",
                  },
                  {
                    question: "Hogyan tudok kiszállni a befektetésből?",
                    answer:
                      "A befektetési alapok többsége nyíltvégű, mely pontosan azt jelenti, hogy bármikor megvehetők és eladhatók a befektetések aktuális értékén. A zártvégű, fix futamidővel rendelkező alapokat eladni (vagy jegyzési időszakot követően megvásárolni) már csak tőzsdei forgalomban lehet (ritkább esetben a befektetési forgalmazó vállalja a visszavásárlást a futamidő vége előtt). Mindkét esetben számolnod kell azzal, hogy a kimutatott értékhez viszonyítva csökkentett (jellemzően 5-15%-kal alacsonyabb) értéken tudod eladni az ilyen típusú alapjaidat. Zártvégű alapokba így elsősorban akkor érdemes befektetned, ha úgy gondolod, hogy meg tudod tartani a futamidő végéig a befektetésedet.",
                  },
                  {
                    question: "Mi garantálja a pénzem biztonságát?",
                    answer:
                      "Ha a befektetési alappal veszteséget érsz el az alapban szereplő befektetések miatt, azért nem jár kártérítés. Ha a befektetési szolgáltatóval (amely értékpapír számlád vezeti) történik valami (pénzügyileg „megbillen”, fizetésképtelenné válik), és nem tudja kiadni számodra a nyilvántartott vagyonod, akkor ilyen esetben jótáll a Befektető-védelmi Alap (BEVA) 100 000 euróig. A követelésed készpénzben térítik meg. Egymillió forintig száz százalékig, az a feletti résznek pedig a kilencven százalékáig. A hozamról sem kell feltétlenül lemondani, hiszen száznyolcvan nap átlagárfolyamán fizetik ki a követelést.",
                  },
                  {
                    question: "Milyen típusú befektetési alapok vannak?",
                    answer:
                      "Befektetési alapokat az általuk tartott értékpapírok (és egyéb befektetéseik) szerint lehet csoportosítani. A hagyományos befektetési alapok a pénzpiaci, a kötvény- és részvényalapok, illetve a két előbbit ötvöző vegyes alapok. Ezek mellett számos egzotikusabb alapot is találhatunk, ilyenek például a szinte bármilyen értékpapírba fektető, és árfolyamesésből is profitáló abszolút hozamú alapok, vagy egy szűk területbe fektető nyersanyag és ingatlan alapok.",
                  },
                  {
                    question: "Kinek érdemes befektetési alapba fektetnie?",
                    answer:
                      "A befektetési alapok sokszínűségének köszönhetően szinte bárki megtalálhatja a hozzá legjobban illő értékpapírokat. Ennek ellenére a befektetési alapok jövőbeli hozama előre nem meghatározható, így azok számára, akik pontosan tudni szeretnék, mikor mekkora hozamot nyújt majd befektetésük (mint, pl. egy bankbetét esetén), azoknak nem a befektetési alapok a legmegfelelőbbek. Viszont mindenki más megtalálhatja a számításait egy megfelelő befektetési alappal!",
                  },
                  {
                    question: "Hogyan kell adóznom a befektetési alapok után?",
                    answer:
                      "A befektetési alapokban elért hozamod után 15%-os személyi jövedelemadót (SZJA) és 13%-os szociális hozzájárulást (szocho) kell fizetned. Ez együttesen az elért hozam 28%-a. (Az ingatlan alapokon elért nyereség után nem szükséges szochót fizetned.) TBSZ használatával ezt akár teljes mértékben elkerülheted.",
                  },
                ],
              },
              {
                key: "lakastakarek",
                label: "Lakástakarék",
                items: [
                  {
                    question:
                      "Hogyan működik egy lakástakarék-pénztári megtakarítás?",
                    answer:
                      "A lakástakarék egy igen egyszerű, havi rendszerességű befizetésekből felépülő, fix futamidejű megtakarítási forma. Segítségükkel magánszemélyek és társasházak valósíthatnak meg lakáscélú megtakarítást.",
                  },
                  {
                    question: "Mik a feltételei a kamatbónusz megszerzésének?",
                    answer:
                      "A pénztárak által fizetett kamatbónusz/prémium nem jár automatikusan, hanem a megszerzéséhez bizonyos feltételeket teljesíteni kell. Mivel állami támogatás már nem kapcsolódik a megtakarításhoz, így utólagos lakáscél-igazolási kötelezettség sincs. Azonban a felhalmozott összeg felvételekor nyilatkozni kell a lakáscélú felhasználásról, ennek hiányában a megtakarító nem jogosult a kamatbónuszra/prémiumra. Fontos továbbá a szerződésszerű, havi rendszerességű betétfizetés, ugyanis ennek elmulasztása is a kamatbónusz részbeni elvesztését eredményezheti.",
                  },
                  {
                    question:
                      "Milyen célokra lehet felhasználni a lakástakarékot?",
                    answer:
                      "A megtakarítás számos módon hasznosítható: lakáscélú felhasználásnak minősül az ingatlanvásárlás, felújítás, korszerűsítés, építés, bővítés, illetve egy lakáshitel előtörlesztése vagy végtörlesztése is.",
                  },
                  {
                    question: "Mekkora összeget lehet befizetni havonta?",
                    answer:
                      "A pénztárak között a havi betétfizetési lehetőségek terén eltérések vannak, de 2023. őszén havonta 10-100 ezer forint közötti befizetéssel lehet új szerződéseket elindítani. Mivel a korábbiakkal ellentétben egy személy párhuzamosan több szerződést is köthet, így a felső limit valójában átléphető.",
                  },
                  {
                    question: "Mennyi pénz gyűlhet össze egy lakástakarékkal?",
                    answer:
                      "A lakáskassza segítségével összegyűjthető pénzösszeg a vállalt havi befizetés mértékétől, a futamidő hosszától, valamint a szolgáltató által fizetett betéti kamat és kamatbónusz/prémium nagyságától függ. Egy konkrét példával szemléltetve: 8 éves (96 hónapos) szerződés esetén, havi 50 ezer forintos betétfizetéssel, 0,1% betéti kamattal és 30%-os egyszeri kamatbónusszal összesen 6 265 008 forint gyűlik össze a számlán. A megtakarítási időszak végén limitált összegű lakáshitel felvételére is lehetőség nyílik, amely tovább növelheti a lakáscélra fordítható összeget.",
                  },
                  {
                    question:
                      "Mekkora hozamot lehet elérni az Erste, az OTP és a Fundamenta lakáskasszával?",
                    answer:
                      "A lakástakarékpénztári megtakarítások hozamát az egységesített betéti kamatláb mutató (EBKM) jelzi. A jelenlegi legkedvezőbb ajánlattal 8 éves időtávon legjobb esetben 6,19%-os hozamot lehet elérni. Az egyes szolgáltatók ajánlatai eltérnek egymástól, ezért a szerződés kiválasztásához érdemes egy hozzáértő tanácsadó segítségét kérni.",
                  },
                  {
                    question: "Kell adót fizetni a lakástakarék után?",
                    answer:
                      "A lakástakarékpénztári megtakarítás teljes adómentességet élvez, azaz sem személyi jövedelemadó, sem szociális hozzájárulási adó, sem tranzakciós illeték nem terheli.",
                  },
                  {
                    question: "Milyen feltételekkel lehet hitelt felvenni?",
                    answer:
                      "A lakástakarékpénztári megtakarítás lejáratkor lakáshitel felvételére is van lehetőség, melynek maximális összege a teljes szerződéses összeg és a felhalmozott megtakarítás különbözete. A lakáshitel kamata előre ismert, a jelenleg elérhető szerződéseknél 5,50% és 7,90% között mozog. Az egyéb költségek miatt azonban a teljes hiteldíj-mutató (THM) ennél magasabb értéket vesz fel.",
                  },
                  {
                    question: "Milyen költségei vannak egy lakástakaréknak?",
                    answer:
                      "A lakástakarékpénztári szerződés megnyitásakor alapesetben számlanyitási díjat kell fizetni, amely jellemzően a szerződéses összeg 1 százaléka. Ugyanakkor erre irányuló akciók keretein belül – bizonyos feltételek teljesítése esetén – elkerülhető a számlanyitási díj megfizetése. A szerződés futamideje alatt havi számlavezetési díj is fizetendő, melynek összege (szolgáltatótól függően) 150-400 forint között mozog. Ennek okán egy havi 50 000 forintos megtakarítás valójában például havi 50 400 forint befizetéssel teljesíthető.",
                  },
                  {
                    question: "Hogyan épül fel a szerződéses összeg?",
                    answer:
                      "A szerződéses összeg annak a mérőszáma, hogy a futamidő végén legfeljebb mennyi pénz állhat az előtakarékoskodó rendelkezésére. A lakáscélra fordítható összeg a saját befizetésekből, a kamatból, a kamatbónuszból/prémiumból és az opcionálisan felvehető hitelből tevődik össze.",
                  },
                  {
                    question:
                      "Kötelező bankszámlát nyitni a lakáskassza mellé?",
                    answer:
                      "A lakástakarék önálló pénzügyi termék, így nem szükséges új bankszámlát nyitni az elindításakor. Mégis érdemes lehet ezt megfontolni, ugyanis a számlanyitási díj elengedésére irányuló akciók gyakori feltétele ez. Emiatt egy bankszámla megnyitása révén akár százezres nagyságrendű kiadást lehet megspórolni.",
                  },
                  {
                    question: "Szükséges kedvezményezettet megjelölni?",
                    answer:
                      "A jelenleg elérhető lakástakarékpénztári szerződéseknél nem kötelező kedvezményezettet megjelölni, még abban az esetben sem, ha valaki több szerződést szeretne elindítani párhuzamosan. (Korábban más volt a helyzet: egy adószámhoz csak egy szerződés tartozhatott.) Kedvezményezett megjelölésére ugyanakkor továbbra is van lehetőség, ami például öröklés esetén előnyös lehet. Az előtakarékoskodó halála esetén ugyanis a szerződést a kedvezményezett örökli meg, és ő rendelkezhet róla: felmondhatja vagy tovább is fizetheti azt. Kedvezményezettként kizárólag közeli hozzátartozót lehet megjelölni.",
                  },
                  {
                    question: "Módosítható időközben a szerződés?",
                    answer:
                      "A havi betétfizetés összege változtatható, de fontos észben tartani, hogy a magasabb kamatbónusz/prémium megszerzéséhez szerződésmódosítás is szükséges. Ha valaki önszorgalomból havi 20 ezer forintos szerződés esetén havi 30 ezer forintos befizetéseket teljesít, akkor a havi 10 ezer forintnyi túlfizetésre nem kap kamatbónuszt. A szerződés futamideje bizonyos szolgáltatóknál módosítható, míg máshol nincs erre lehetőség, ezért ebben a kérdésben érdemes egy hozzáértő tanácsadó segítségét kérni. A kedvezményezett a futamidő során is módosítható.",
                  },
                  {
                    question:
                      "Mennyi ideig tart az összegyűjtött pénz kiutalása?",
                    answer:
                      "A kiutalási idő alapesetben 2 hónap. Ennek meggyorsítására is van lehetőség, 3%-os költség fejében.",
                  },
                  {
                    question: "Meddig lesznek elérhetők ezek a lakástakarékok?",
                    answer:
                      "2023-ban több szolgáltató is úgy döntött, hogy ismét belép a lakástakarékok piacára, hiszen a magas piaci hozamszintek által most zsebből is képesek kigazdálkodni az akár 30%-os kamatbónuszt/prémiumot. Azonban a hozamszintek rendeződése (csökkenése) után erre valószínűleg nem lesz lehetőségük, így feltételezhetjük, hogy belátható időn belül rosszabbodni fog a most elérhető lakástakarékok ajánlata.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
